import { ArrowUpRight } from "lucide-react";
import { KICKSTARTER_URL } from "@/lib/links";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy px-6 pb-10 pt-20 text-paper md:px-12">
      <div className="mx-auto max-w-[1280px]">
        <div className="flex flex-col justify-between gap-10 border-b-2 border-paper/15 pb-14 md:flex-row md:items-end">
          <div>
            <p className="font-display text-5xl font-extrabold uppercase tracking-tight md:text-7xl">
              Bookata<span className="text-punch">*</span>
            </p>
            <p className="mt-4 font-serif text-xl italic text-banana">
              The right dish, the perfect place, the proper time.
            </p>
          </div>
          <div className="space-y-3 text-sm md:text-right">
            <a
              href="https://bookata.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-bookata-link"
              className="inline-flex items-center gap-1.5 font-bold uppercase tracking-wider text-paper underline decoration-punch decoration-2 underline-offset-4 transition-colors duration-300 hover:text-banana"
            >
              bookata.com <ArrowUpRight className="h-4 w-4" />
            </a>
            <p className="text-paper/60">Illustrated with a little help from Gemini &amp; Spark.</p>
          </div>
        </div>
        <div className="flex flex-col justify-between gap-2 pt-6 text-[11px] font-bold uppercase tracking-[0.25em] text-paper/50 md:flex-row">
          <p>© 2026 Bookata. All rights reserved.</p>
          <a
            href={KICKSTARTER_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-kickstarter-link"
            className="transition-colors duration-300 hover:text-banana"
          >
            2027 Calendario Gastronomico — on Kickstarter ↗
          </a>
        </div>
      </div>
    </footer>
  );
}
